<template>
  <div class="container md-layout">
    <md-progress-bar md-mode="query" class="md-accent" v-if="loading"></md-progress-bar>
    <div class="md-layout-item md-size-100" v-else>
      <md-table md-card>
        <md-table-toolbar>
          <h1 class="md-title">{{ $t("stadiums.list.title") }}</h1>
        </md-table-toolbar>

        <md-table-row>
          <md-table-head>{{$t('stadiums.list.name')}}</md-table-head>
          <md-table-head>{{$t('stadiums.list.edit')}}</md-table-head>
        </md-table-row>

        <md-table-row v-for="stadium in listStadiums" :key="stadium.id">
          <md-table-cell>{{stadium.name}}</md-table-cell>
          <md-table-cell>
              <md-button class="md-info" :to="`/stadiums/${stadium.id}`">
              {{$t('stadiums.list.edit')}}

              </md-button>
          </md-table-cell>
        </md-table-row>
      </md-table>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      listStadiums: state => state.StuffModule.stadiums
    })
  },
  data() {
    return {
      loading: true
    }
  },
  mounted() {
    this.$store.dispatch("getStadiums")
      .then(() => this.loading = false)
  }
};
</script>